import styled from 'styled-components';

export const Container = styled.div`
    padding: 2rem;
    font-weight: 500;
    font-size: 36px;
    line-height: 42px;

    color: #92140C;
    text-align: center;
`;
